/**
 * Small helpers the list hooks share (SDD-017): every list hook turns its typed filter into
 * `filters` with the SDK builder; these keep the rest of the request — the page, the cache key —
 * spelled one way.
 */

/** A string that says something: undefined and `''` are "not filtered". */
export function isSet(value: string | undefined): value is string {
  return value !== undefined && value !== '';
}

/** The catalog's `tarifSlug` of a tarif ERN (`tarifservice:fahrrad` → `fahrrad`); a bare slug passes. */
export function tarifSlugOf(tarifErn: string | undefined): string | undefined {
  if (!isSet(tarifErn)) return undefined;
  const slug = tarifErn.startsWith('tarifservice:')
    ? tarifErn.slice('tarifservice:'.length)
    : tarifErn;
  return slug === '' ? undefined : slug;
}

/** The paging half of a list request. The token is opaque: passed back verbatim, never built. */
export function pageOf(filter: { readonly pageSize?: number; readonly pageToken?: string }): {
  pageSize?: number;
  pageToken?: string;
} {
  return {
    ...(filter.pageSize !== undefined && filter.pageSize > 0 ? { pageSize: filter.pageSize } : {}),
    ...(isSet(filter.pageToken) ? { pageToken: filter.pageToken } : {}),
  };
}

/** The cache key's view of a query: every value a string, so `{pageSize: 10}` and `'10'` are one entry. */
export function listQueryKey(query: object): Record<string, string> {
  const out: Record<string, string> = {};
  for (const [name, value] of Object.entries(query)) {
    if (value === undefined || value === null) continue;
    if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
      out[name] = String(value);
    }
  }
  return out;
}
